export const BuildingUserConstants = {
  SetBuildingUsers: 'BUILDING_USER_CONSTANTS.SET_BUILDING_USERS',
  CreateUserInvite: 'BUILDING_USER_CONSTANTS.CREATE_USER_INVITE',
  ValidateUserInvite: 'BUILDING_USER_CONSTANTS.VALIDATE_USER_INVITE',
  ReceiveValidInvite: 'BUILDING_USER_CONSTANTS.RECEIVE_VALID_INVITE',
  InviteAccepted: 'BUILDING_USER_CONSTANTS.INVITE_ACCEPTED',
  StartLoading: 'BUILDING_USER_CONSTANTS.START_LOADING',
  SetUserScopes: 'BUILDING_USER_CONSTANTS.SET_USER_SCOPES',
  SetUserActionSuccess: 'BUILDING_USER_CONSTANTS.SET_USER_ACTION_SUCCESS',
  ClearUserActionSuccess: 'BUILDING_USER_CONSTANTS.CLEAR_USER_ACTION_SUCCESS',
  SetBuildingUserError: 'BUILDING_USER_CONSTANTS.SET_BUILDING_USER_ERROR',
  ClearBuildingUserError: 'BUILDING_USER_CONSTANTS.CLEAR_BUILDING_USER_ERROR',
};

// ACTION Types
interface CreateUserInviteAction {
  type: typeof BuildingUserConstants.CreateUserInvite;
  payload: undefined;
}

interface ReceiveValidInviteAction {
  type: typeof BuildingUserConstants.ReceiveValidInvite;
  payload: ValidInviteInformation;
}

interface InviteAcceptedAction {
  type: typeof BuildingUserConstants.InviteAccepted;
  payload: undefined;
}

interface StartLoadingAction {
  type: typeof BuildingUserConstants.StartLoading;
  payload: undefined;
}

interface SetUserScopesAction {
  type: typeof BuildingUserConstants.SetUserScopes;
  payload: UserScope[];
}

interface SetUserActionSuccessAction {
  type: typeof BuildingUserConstants.SetUserActionSuccess;
  payload: string;
}

export type BuildingUserActionTypes =
  | CreateUserInviteAction
  | ReceiveValidInviteAction
  | InviteAcceptedAction
  | StartLoadingAction
  | SetUserScopesAction
  | SetUserActionSuccessAction;

// STATE slices
export interface ValidInviteInformation {
  is_existing_user: boolean;
  email: string;
  is_valid: boolean;
  is_accepted: boolean;
  api_location: string;
}

export interface BuildingUserOptionType {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface UserScope {
  identifier: string;
  name: string;
  description: string;
  is_read_only: boolean;
  remove_api_location: string;
}

export interface BuildingUserResponseType {
  count: number;
  next: string | null;
  previous: string | null;
  results: BuildingUserType[];
}

export interface BuildingUserType {
  building: string;
  email: string;
  first_name: string;
  last_name: string;
  user_role: string;
  phone_number: string;
  permission_scopes: UserScope[];
  resend_invite_api_location: string;
  reset_password_api_location: string;
  revoke_access_api_location: string;
  add_permission_api_location: string;
  show_resend: boolean;
  show_reset_password: boolean;
  status: string;
  uid_hash: string;
}

export interface BuildingUserReducer {
  buildingUsers: BuildingUserResponseType;
  validInviteInformation: undefined | ValidInviteInformation;
  inviteAccepted: boolean;
  userScopes: UserScope[];
  isLoading: boolean;
  inviteCreated: boolean;
  error: string;
  successMessage: string;
}
